import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from 'lang/i18n';
import DialogInput from 'screens/components/advanced/DialogInput';
import BranchSelectAutoComplete from 'screens/components/basic/BranchSelectAutoComplete';
import { setBranchContext, getUserBranches } from 'actions/CommonActions';
import { getSettings, getUserRolePageByName } from 'actions/EntityActions';
import DialogHeader from 'screens/components/basic/DialogHeader';

class BranchDialogHiTides extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            modalIsOpen: false,
            searchText: ''
        };
    }

    componentWillMount() {
        const selectedStore = localStorage.getItem('TECHPOS_CompanyCode') || ``;
        if (this.props.isUserAuthenticated === true && this.props.userBranches === undefined && selectedStore) {
            this.props.getUserBranches(this.props.userName);
            const userRole = this.props.authenticatedUser.roles;
            this.props.getUserRolePageByName(userRole[0]);
        }
        if (this.props.isUserAuthenticated === true && this.props.userBranches === undefined && selectedStore) {
            const storedBranchId = localStorage.getItem('TECHPOS_SELECTED_BRANCH');
            if (storedBranchId !== undefined && storedBranchId !== null) {
                this.props.setBranchContext(parseInt(storedBranchId));
                this.props.getSettings(storedBranchId, 'SettingsPage');
            }
        }
    }

    componentWillReceiveProps(newProps) {
        const selectedStore = localStorage.getItem('TECHPOS_CompanyCode') || ``;
        // get user branches when its not loaded
        if (newProps.isUserAuthenticated !== this.props.isUserAuthenticated && newProps.isUserAuthenticated === true && newProps.userBranches == undefined && newProps.userName && selectedStore) {
            this.props.getUserBranches(newProps.userName);
            const userRole = newProps.authenticatedUser.roles;
            this.props.getUserRolePageByName(userRole[0]);
        }

        // check if user must select a branch or not
        if (selectedStore && (newProps.selectedBranchId === null && newProps.isUserAuthenticated === true) || (this.props.userBranches !== newProps.userBranches && newProps.branchId > 0)) {
            if (newProps.userBranches) {
                // if more than one branch show dialog to choose branch
                if (newProps.userBranches.length > 1) {
                    this.setState({ modalIsOpen: true });
                }
                else {
                    // if none it is Admin profile, set branchId to 0
                    if (newProps.userBranches.length === 0) {
                        this.props.setBranchContext(0);
                    }
                    // set the branchId to the one that user has access
                    else {
                        this.props.setBranchContext(newProps.userBranches[0].id);
                        this.props.getSettings(newProps.userBranches[0].id, 'SettingsPage');
                    }
                }
            }
        }
    }

    handleUpdateInput = (searchText) => this.setState({ searchText });

    handleNewRequest = (chosenRequest, index) => {
        const branchId = index.value; // or directly chosenRequest.id based on your structure
        this.selectedBranchId(branchId);
        this.setState({ modalIsOpen: false });
        
        const branches = this.props.userBranches;
        const branch = branches.find(branch => branch.id === branchId);
        
        if (branch.country) {
            if (branch.country.toLowerCase() === 'ca' || branch.country.toLowerCase() === 'canada') {
                localStorage.setItem('language', 'en');
                i18n.changeLanguage('en');
            }
            else if (branch.country.toLowerCase() === 'de' || branch.country.toLowerCase() === 'germany') {
                localStorage.setItem('language', 'de');
                i18n.changeLanguage('de');
            }
        }
    };


    selectedBranchId = id => {

        this.props.setBranchContext(id);
        this.setState({ modalIsOpen: false });
        this.props.getSettings(id, 'SettingsPage');
        localStorage.setItem("TECHPOS_PastDueDialog", "");
    }

    render() {
        const p = this.props;
        const branches = p.userBranches || [];

        const dataSource = branches.map(branch => ({
            text: branch.name,
            value: branch.id
        }));
        // 

        return (
            <DialogInput
                title={<DialogHeader text="Select a Branch" classicClass="posDialogClassic large-dialog-title" />}
                modal={true}
                open={this.state.modalIsOpen}
                style={{ width: '50%' }}
                autoScrollBodyContent={true}>
                <BranchSelectAutoComplete
                    dataSource={dataSource}
                    onNewRequest={this.handleNewRequest}
                    onUpdateInput={this.handleUpdateInput}
                />
            </DialogInput>
        );
    }
}


function mapStateToProps(state) {
    return {
        selectedBranchId: state.common.branchId,
        isUserAuthenticated: state.common.isUserAuthenticated,
        userBranches: state.common.userBranches,
        userName: state.common.authenticatedUser ? state.common.authenticatedUser.userName : '',
        authenticatedUser: state.common.authenticatedUser
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setBranchContext: (branchId) => dispatch(setBranchContext(branchId)),
        getUserBranches: (userName) => dispatch(getUserBranches(userName)),
        getSettings: (branchId, compName) => dispatch(getSettings(branchId, compName)),
        getUserRolePageByName: (roleName) => dispatch(getUserRolePageByName(roleName))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BranchDialogHiTides);